import styled from 'styled-components'

export default styled.div`
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  text-transform: lowercase;
`
